/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 19:07:54
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import { modalFactory } from 'src/util/vueExtend';
import CompareExceptionApi from './api/compareExceptionApi';
import { createNamespace } from 'src/util/bem';
import EnumExceptionStatus, { EnumExceptionTaskDealStatus } from 'src/enums/enumExceptionStatus';

export namespace ViewExceptionCompareVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        dispose_company: string;
        inform_number: string;
        initiator: string;
        sponsor_datetime: string;
        abnormity_site: {
            dispose_condition: number;
            dispose_datatime: string;
            dispose_explain: string;
            dispose_people: string;
            dispose_people_id: number;
            dispose_site: string;
            operational_content: string;
            operational_equipment: string[];
            operational_site: string;
            operational_id: number;
            ops_leader_status: number;
            task_number: string;
        }[];
    }
}

@Component
class ViewExceptionCompareModal extends Vue.Component<ViewExceptionCompareVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: ViewExceptionCompareVOI.FormDataI = {
        dispose_company: '',
        inform_number: '',
        initiator: '',
        sponsor_datetime: '',
        abnormity_site: [],
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async mounted() {
        let { code, data } = await CompareExceptionApi.searchDetail({ id: this.id });
        if (code === 0) {
            this.formData = {
                dispose_company: data.dispose_company,
                inform_number: data.inform_number,
                initiator: data.initiator,
                sponsor_datetime: data.sponsor_datetime,
                abnormity_site: data.abnormity_site.data,
            };
        }
    }
    render(h) {
        return (
            <Modal title="异常通知详情" width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close} footer-hide>
                <i-form ref="formValidate" labelWidth={80} class={createNamespace('detail-form')} model={this.formData}>
                    <form-item labelWidth={80} label="通知单号：" style="display: inline-block;width:30%">
                        {this.formData.inform_number}
                    </form-item>
                    <form-item labelWidth={80} label="处理单位：" style="display: inline-block;width:30%">
                        {this.formData.dispose_company}
                    </form-item>
                    <form-item labelWidth={80} label="发起人" style="display: inline-block;width:20%">
                        {this.formData.initiator}
                    </form-item>
                    <form-item labelWidth={80} label="发起时间" style="display: inline-block;width:20%">
                        {this.formData.sponsor_datetime}
                    </form-item>

                    {this.formData.abnormity_site.map(i => {
                        return (
                            <div class={createNamespace('mt15')}>
                                <form-item label="异常站点：" style="display: inline-block;width:90%">
                                    {i.operational_site}
                                </form-item>
                                <form-item label="异常设备：" style="display: inline-block;width:90%">
                                    {(i.operational_equipment || []).join('、')}
                                </form-item>
                                <form-item label="异常内容：" style="display: inline-block;width:90%">
                                    {i.operational_content}
                                </form-item>
                                <form-item label="处理情况：" style="display: inline-block;width:30%">
                                    {EnumExceptionTaskDealStatus.findId(i.dispose_condition).getName()}
                                </form-item>
                                <form-item label="处理原因：" style="display: inline-block;width:60%">
                                    {i.dispose_explain}
                                </form-item>
                                <form-item label="处理人" style="display: inline-block;width:30%">
                                    {i.dispose_people}
                                </form-item>
                                <form-item label="处理时间：" style="display: inline-block;width:60%">
                                    {i.dispose_datatime}
                                </form-item>
                            </div>
                        );
                    })}
                </i-form>
            </Modal>
        );
    }
}

export default function alertViewExceptionCompareModal(id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<ViewExceptionCompareVOI.PropsI>(ViewExceptionCompareModal)({
            id,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
